import "./style.css";
import ReactDataTable from "../../Components/ReactDataTable";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useMemo } from "react";
import {
  Box,
  List,
  Stack,
  Button,
  ButtonGroup,
  Typography,
} from "@mui/material";
import HelmetReact from "../../Components/Helmet";
import { getFeedBack, removeFeedBack } from "../../Redux/Actions/FeedBack";
import FilterComponent from "../../Components/ReactDataTable/FilterComponent";
import ActionButton from "../../Components/ReactDataTable/ActionButton";
import ResponsiveDialog from "../../Components/DialogBox";
import { useErrorHandler } from "../../hooks";

export const FeedBack = () => {
  const dispatch = useDispatch();
  const { FeedBackList, totalRows, loading } = useSelector(
    (state) => state.FeedBack
  );
  const userData = JSON.parse(localStorage.getItem("userData"));
  const [selectedTab, setSelectedTab] = useState("CLIENTS");
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [itemId, setItemId] = useState();
  const { setMsgConfig } = useErrorHandler();
  let data;
  data = FeedBackList?.map((e) => e);
  const [navigateUrl, setNavigateUrl] = useState("/feedback/overview/");
  const EMOJI_TYPES = {
    1: "1F629",
    2: "1F615",
    3: "1F610",
    4: "1F642",
    5: "1F603",
  };
  useEffect(() => {
    setNavigateUrl(`/feedback/clients/`);
  }, [selectedTab]);
  const onTableChange = (filter) => {
    if (selectedTab === "CLIENTS") {
      const searchPayload = {
        key: filterText || "",
        perPage: filter?.perpage || 10,
        page: filter?.page || 1,
        sortBy: filter?.sortBy || "Id",
        sortDirection: filter?.direction || "ASC",
      };
      dispatch(getFeedBack(searchPayload));
    }
  };
  useEffect(() => {
    if (selectedTab === "CLIENTS") {
      dispatch(getFeedBack());
    }
  }, [selectedTab, dispatch]);
  useEffect(() => {
    onTableChange();
  }, [selectedTab, filterText]);
  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };
    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e)}
        onClear={handleClear}
        filterText={filterText}
        placeHolder="Search by name"
      />
    );
  }, [filterText, resetPaginationToggle]);

  const RemoveItem = (item) => {
    setIsVisibleModal(true);
    setItemId(item?.Id);
  };

  const handleConfirm = () => {
    const payload = {
      Id: itemId,
    };
    dispatch(removeFeedBack(payload));
    setIsVisibleModal(false);
    setMsgConfig({
      alertOpen: true,
      message: "Remove Explore SuccessFully!!",
      severity: "success",
      autoHideDuration: 1000,
    });
  };

  const columns = [
    {
      name: "NAME",
      sortField: "name",
      sortable: true,
      selector: (row) => row.name,
      cell: (row) => {
        return (
          <span className="badge bg-light-danger">
            <span>{row?.user?.first_name + " " + row?.user?.last_name}</span>
          </span>
        );
      },
    },
    {
      name: "EMAIL",
      sortField: "email",
      selector: (row) => row?.user?.email,
      sortable: true,
      cell: (row) => {
        return (
          <span className="badge bg-light-danger">
            <span>{row?.user?.email}</span>
          </span>
        );
      },
    },
    {
      name: "PROGRAM",
      sortField: "program",
      sortable: true,
      selector: (row) => row?.program?.title,
      cell: (row) => {
        return (
          <span className="badge bg-light-danger">
            <span>{row?.program?.title}</span>
          </span>
        );
      },
    },
    {
      name: "MOOD",
      sortField: "rating",
      sortable: true,
      selector: (row) => row?.rating,
      cell: (row) => {
        return (
          <Typography
            // style={{ "font-size": "30px" }}
            component={"span"}
            sx={{ fontSize: "30px" }}
            className="badge bg-light-danger"
          >
            {row?.rating ? (
              String.fromCodePoint(`0x${EMOJI_TYPES[`${row?.rating}`]}`)
            ) : (
              <Typography
                component={"span"}
                sx={{ fontSize: "30px" }}
                // style={{ "font-size": "20px" }}
                className="badge bg-light-danger"
              >
                -
              </Typography>
            )}
          </Typography>
        );
      },
    },
    {
      name: "DATE CREATED",
      sortField: "created_at",
      selector: (row) => row.created_at,
      sortable: true,
      cell: (row) => {
        return (
          <span className="badge bg-light-danger">
            <span>
              {row.created_at
                ? moment(row.created_at).format("DD/MM/YYYY")
                : "N/A"}{" "}
            </span>
          </span>
        );
      },
    },
    {
      name: "COMMMENT",
      sortField: "feedback",
      sortable: true,
      selector: (row) => row?.feedback,

      cell: (row) => {
        return (
          <span className="badge bg-light-danger">
            <span>{row?.feedback ? row?.feedback : "-"}</span>
          </span>
        );
      },
    },
    {
      name: "ACTION",
      right: true,
      omit: userData?.role === "researcher" ? true : false,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      cell: (row) => {
        return (
          <>
            <span className="remove-icon-btn view-detail-btn">
              <ActionButton
                isRemoveIcon={true}
                RemoveItem={RemoveItem}
                item={row}
                isEditMode={true}
              />
            </span>
          </>
        );
      },
    },
  ];
  return (
    <>
      <HelmetReact name="FeedBack" />
      <ResponsiveDialog
        dtype="confirm"
        open={isVisibleModal}
        header="Are you sure you want to delete this Feedback?"
        onConfirm={() => handleConfirm()}
        onClose={() => setIsVisibleModal(false)}
      ></ResponsiveDialog>
      <Box className="d-details-box">
        <ButtonGroup variant="text" aria-label="text button group">
          <Button
            className={`${selectedTab === "CLIENTS" ? "active" : ""}`}
            onClick={() => {
              setSelectedTab("CLIENTS");
              setFilterText("");
            }}
          >
            CLIENTS
          </Button>
        </ButtonGroup>
        <List component={Stack} direction="row"></List>

        <ReactDataTable
          columns={columns}
          items={data}
          totalRows={totalRows}
          onChange={onTableChange}
          isLoading={loading}
          navigateUrl={navigateUrl}
          isShowSearch={true}
          paginationResetDefaultPage={resetPaginationToggle}
          subHeader
          subHeaderComponent={subHeaderComponentMemo}
          persistTableHead
        />
      </Box>
    </>
  );
};
